






































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { EditionInfo } from '@/models/edition';
import { SearchBarParams } from '@/components/search-bar.vue';

import Waiting from '@/components/misc/Waiting.vue';
import SearchBar from '@/components/search-bar.vue';
import EditionList from './edition-list.vue';
import { SearchBarValue } from '@/state/utilities';

@Component({
    name: 'personal-editions',
    components: {
        Waiting,
        SearchBar,
        EditionList,
    },
})
export default class PersonalEditions extends Vue {
    private filteredEditions: EditionInfo[] = [];
    public searchBarParams: SearchBarParams = {
        filter: true,
        sort: true,
        side: false,
    };

    public get searchValue() {
        return this.$state.misc.editionSearchBarValue;
    }

    public set searchValue(newVal: SearchBarValue) {
        this.$state.misc.editionSearchBarValue = newVal;
    }

    public onEditionsSearch(newSearch: SearchBarValue) {
        this.searchValue = newSearch;
        this.onPersonalEditionsLoad();
    }

    @Watch('$state.misc.editionSearchBarValue', {deep: true})
    public onSearchValueChanged() {
        this.onPersonalEditionsLoad();
    }

    @Emit()
    public onPersonalEditionsLoad() {
        this.filteredEditions = this.getFilteredEditions();
        return this.filteredEditions.length;
    }

    protected async mounted() {
        await this.$state.prepare.allEditions();
        this.onPersonalEditionsLoad();
    }

    private getFilteredEditions(): EditionInfo[] {
        return this.$state.editions.items
            .filter((ed: EditionInfo) => {
                let filter: boolean = ed.mine === true;
                // if (this.searchValue.view) {
                //     filter = filter && art.side === this.searchValue.view
                // }
                if (this.searchValue.filter) {
                    filter =
                        filter &&
                        ed.name
                            .toLowerCase()
                            .includes(this.searchValue.filter.toLowerCase());
                }
                return filter;
            })
            .sort((a: EditionInfo, b: EditionInfo) => {

                if (this.searchValue.sort) {
                    let aVal = (a as any)[this.searchValue.sort];
                    let bVal = (b as any)[this.searchValue.sort];

                    if ( 'name' === this.searchValue.sort ) {
                        return aVal.localeCompare( bVal ,   undefined,
                            { numeric: true, sensitivity: 'base' }
                        );

                    } else if ( 'lastEdit' === this.searchValue.sort ) {

                       // for undefined dates, take 01/01/1970 as default
                        if ( undefined === aVal ) {
                            aVal = new Date(1970, 1, 1, 1, 1, 1);
                        }
                        if ( undefined === bVal ) {
                            bVal = new Date(1970, 1, 1, 1, 1, 1);
                        }
                        return ((aVal > bVal) ? -1 :  1 );

                    } else {
                        return ((aVal > bVal) ? 1 : -1 );
                    }

                } else {
                    return 1;
                }
            });
    }

    public get draftEditions(): EditionInfo[] {
        return this.filteredEditions.filter((ed) => !ed.isPublic);
    }

    public get publishedEditions(): EditionInfo[] {
        return this.filteredEditions.filter((ed) => ed.isPublic);
    }
}
